import {
  showFollowUp,
  editFollowUp,
  createFollowUp,
  storeFollowUp,
  updateFollowUp,
  createNextFollowUp,
} from '@app/api/follow-up.api';
import { getCustomerImports } from '@app/api/import.api';
import { BaseCard } from '@app/components/common/BaseCard/BaseCard';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';
import { notificationController } from '@app/controllers/notificationController';
import { FollowUpRequest } from '@app/models/follow_up/FollowUpRequest';
import { Form, notification, Tabs, Input, Select } from 'antd';
import { Tab } from 'rc-tabs/lib/interface';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import FollowUpInfo from './FollowUpInfo';
import { DropdownOption } from '@app/models/DropdownOption';
import { authUserService } from '@app/services/authUser.service';
import { Customer } from '@app/models/customer/Customer';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { useTranslation } from 'react-i18next';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { CustomerInfoForm } from '@app/components/forms/CustomerInfoForm/CustomerInfoForm';
import StatusBar from '@app/components/statusBar/statusBar';
import { CustomerDTO } from '@app/models/customer/CustomerDTO';
import { ImportDropdownItem } from '@app/models/import/ImportResponse';
import AdditionalInfo from './AdditionalInfo';
import CommentsTab from '../common/followUp/Comments';
import DoumentCheckList from './DoumentCheckList';
import PaymentsInfo from './PaymentsInfo';
import ProductInfo from './ProductInfo';
import BillingInfo from './BillinInfo';

const { Search } = Input;

interface TypeOfForm {
  type: 'edit' | 'create' | 'view';
}

interface FollowUpFormProps extends TypeOfForm {
  editable: boolean;
  id?: string;
  import_id?: number | null;
  showEditIcon?: boolean;
  pageTitle: React.ReactNode;
  // eslint-disable-next-line @typescript-eslint/ban-types
  setCurrentBreadcrumName: Function;
  setActionAfterFail?: React.Dispatch<React.SetStateAction<string>>;
  setFailureActions?: React.Dispatch<React.SetStateAction<any[]>>;
}

const FollowUpForm: React.FC<FollowUpFormProps> = ({
  editable = false,
  id,
  import_id,
  pageTitle,
  type,
  setCurrentBreadcrumName,
  setActionAfterFail,
}) => {
  const [form] = Form.useForm();
  const [isLoading, setLoading] = useState(false);
  const [status, setStatus] = useState<string | null>(null);
  const navigate = useNavigate();
  const [referenceCode, setReferenceCode] = useState<string>('');
  const [code, setCode] = useState<string>('');
  const [comments, setComments] = useState([]);
  const [customerId, setCustomerId] = useState<number | null>(null);
  const [statusOptions, setStatusOptions] = useState<DropdownOption[]>([]);
  const [typeOptions, setTypeOptions] = useState<DropdownOption[]>([]);
  const [countries, setCountries] = useState<DropdownOption[]>([]);
  const [acceptedFields, setAcceptedFields] = useState([]);
  const user = authUserService.getUser();
  const { t } = useTranslation();
  const { addHeaderButton, removeHeaderButton } = useHeader();
  const [wfActions, setWfActions] = useState<string[]>([]);
  const [customerData, setCustomerData] = useState<CustomerDTO | null>(null);
  const [customerEmail, setCustomerEmail] = useState<string | null>(null);
  const [customerStatus, setCustomerStatus] = useState<string | null>(null);
  const [importOptions, setImportOptions] = useState<ImportDropdownItem[]>([]);
  const [selectedImport, setSelectedImport] = useState<any>(null);
  const [FollowUpData, setFollowUpData] = useState<any>(null);
  const [product, setProduct] = useState<any>(null);
  const [lineData, setlineData] = useState<any>(null);
  const [additionalSubmittedDocs, setadditionalSubmittedDocs] = useState<any[]>([]);
  const followUpId = id ? parseInt(id) : null;
  const [invoiceData, setInvoiceData] = useState<any[]>([]);
  const [serviceCharges, setServiceCharges] = useState<any[]>([]);
  const [canCreateFollowUp, setCanCreateFollowUp] = useState<any[]>([]);
  const [arrivalLine, setarrivalLine] = useState<any>(null);
  const [departmentId, setDepartmentId] = useState<any>(null);
  const [importLineVarieties, setImportLineVarieties] = useState<any[]>([]);
  const [serviceChargeOptions, setServiceChargeOptions] = useState<any[]>([]);
  const [selectedCountries, setSelectedCountries] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useState<string>('1');
  const [uploadAdditional, setUploadAdditional] = useState<any[]>([]);
  const [failureActions, setFailureActions] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);

  const items: Tab[] | undefined = [
    {
      key: '1',
      label: 'Customer Info',
      children: (
        <CustomerInfoForm
          form={form}
          type={type}
          customerInfo={customerData}
          createType={'Follow-Up'}
          // email={customerEmail}
          // status={customerStatus}
        />
      ),
    },
    {
      key: '2',
      label: 'Follow-Up Info',
      children: (
        <FollowUpInfo
          editable={editable}
          acceptedFields={acceptedFields}
          setAcceptedFields={setAcceptedFields}
          form={form}
          productCategories={[]}
          //country_options={countries}
          importData={selectedImport}
          FollowUpData={FollowUpData}
          countries={selectedCountries}
        />
      ),
    },
    {
      key: '3',
      label: 'Product Info',
      children: (
        <ProductInfo
          product={product}
          editable={editable}
          form={form}
          lineData={lineData}
          serviceCharges={serviceCharges}
          FollowUpData={FollowUpData}
          arrivalData={arrivalLine}
          departmentId={departmentId}
          importLineVarieties={importLineVarieties}
          serviceChargeOptions={serviceChargeOptions}
          follow_up_id={id ? Number(id) : null}
        />
      ),
    },
    // {
    //   key: '4',
    //   label: 'Additional Info',
    //   children: (
    //     <div style={{ width: '90vw', marginLeft: '-24px', paddingLeft: '24px' }}>
    //       <AdditionalInfo editable={editable} form={form} FollowUpData={FollowUpData} />
    //     </div>
    //   ),
    // },
    // {
    //   key: '4',
    //   label: 'Billing Info',
    //   children: (
    //     <BillingInfo
    //       form={form}
    //       FollowUpData={FollowUpData}
    //       serviceCharges={serviceCharges}
    //       import_id={import_id}
    //       department={FollowUpData?.import?.department_id ?? form.getFieldValue('departmentId')}
    //       editInfo={editable}
    //     />
    //   ),
    // },
    ...(status !== null && status !== 'DRAFT' && status !== 'PENDING_PAYMENT'
      ? [
          {
            key: '6',
            label: 'Documents',
            children: (
              <div
                style={{
                  width: '100vw',
                  marginLeft: '-24px',
                  paddingLeft: '24px',
                  marginRight: '-100px',
                  overflowX: 'hidden',
                }}
              >
                <DoumentCheckList
                  follow_up_id={id ?? ''}
                  editable={editable}
                  additionalSubmittedDocs={additionalSubmittedDocs}
                  canUpload={uploadAdditional}
                />
              </div>
            ),
          },
        ]
      : []),
    ...(status !== null && status !== 'DRAFT'
      ? [
          {
            key: '9',
            label: t('Invoice'),
            children: (
              <PaymentsInfo
                id={id ?? null}
                pr_code={code}
                invoice_data={invoiceData}
                invoiceType="FU"
                fu_status={status}
              />
            ),
          },
        ]
      : []),
    {
      key: '10',
      label: 'Comments',
      children: <CommentsTab status={status} commentData={comments} follow_up_id={id ?? null} />,
    },
  ];

  const populateImportFields = (selected: any) => {
    setSelectedImport(selected);
    form.setFieldsValue({
      allowed_weightage: selected.allowed_weightage,
      consignment_status: selected.consignment_status,
      country_ids: selected.countries.map((c: any) => c.id),
    });
  };

  const setApiData = (res: any) => {
    const preClearance = res?.pre_clearance;
    setStatus(res?.follow_up?.status ?? 'New');
    setStatusOptions(res?.follow_up?.status ?? 'New');
    setCurrentBreadcrumName(res?.follow_up?.id ?? 'New');
    setCode(res?.follow_up?.code ?? 'N/A');
    setReferenceCode(res?.follow_up?.reference_code ?? 'N/A');
    setAcceptedFields(res?.follow_up?.accepted ?? []);
    setCountries(res?.countries ?? []);
    setComments(res?.follow_up?.follow_up_comments ?? []);
    setCustomerId(res?.follow_up?.customer?.id ?? user?.customer?.id);
    setWfActions(res?.wf_actions ?? []);
    setFollowUpData(res?.follow_up ?? {});
    setCustomerData(res?.follow_up?.customer ?? []);
    setServiceCharges(res?.follow_up?.follow_up_service_charges ?? []);
    setCanCreateFollowUp(res.follow_up?.can_create ?? false);
    setadditionalSubmittedDocs(res?.follow_up?.follow_up_documents ?? []);
    setProduct(
      (res?.follow_up?.import?.import_lines ?? [])
        .map((line: { product: { id: any; name: any }; quantity: number }) =>
          line.product
            ? {
                id: line.product.id,
                name: line.product.name,
                quantity: line.quantity,
              }
            : null,
        )
        .filter(Boolean),
    );
    setInvoiceData(res?.follow_up?.invoices ?? []);
    setlineData(res?.follow_up?.followup_lines ?? []);

    form.setFieldsValue({
      status: res?.follow_up?.status,
      allowed_weightage: res?.follow_up?.import?.allowed_weightage,
      consignment_status: res?.follow_up?.import?.consignment_status,
      departmentId: res?.follow_up?.import?.department_id,
      expire_date: res?.follow_up?.expire_date ? dayjs(res.follow_up.expire_date) : null,
      qty: res?.follow_up?.qty,
      start_date: res?.follow_up?.start_date ? dayjs(res.follow_up.start_date) : null,
      end_date: res?.follow_up?.end_date ? dayjs(res.follow_up.end_date) : null,
      billing_days: res?.follow_up?.billing_days,
      billing_qty: res?.follow_up?.billing_qty,
      //country_ids: res?.follow_up?.import?.countries.map((c: any) => c.id),
    });
    setarrivalLine(res?.follow_up?.arrival_line ?? []);
    setDepartmentId(res?.follow_up?.department_id ?? null);
    setImportLineVarieties(res?.follow_up?.import_line_varieties ?? []);
    setServiceChargeOptions(res?.service_charge_options ?? []);
    setSelectedCountries(res?.follow_up?.import?.countries ?? []);
    setUploadAdditional(res?.follow_up?.can_upload ?? false);
    setFailureActions?.(res?.action_after_failure_options ?? []);
    setActionAfterFail?.(res?.follow_up?.action_after_failure ?? '');
  };

  useEffect(() => {
    setLoading(true);
    if (id) {
      if (type === 'view') {
        showFollowUp(Number(id))
          .then((res: any) => {
            setApiData(res);
            setLoading(false);
          })
          .catch((err: any) => {
            setLoading(false);
            notification.error({ message: 'Failed to fetch FollowUp', description: err.message });
            console.error(err);
          });
      } else if (type === 'edit') {
        editFollowUp(Number(id))
          .then((res: any) => {
            setApiData(res);
            setLoading(false);
          })
          .catch((err: any) => {
            setLoading(false);
            notification.error({ message: 'Failed to edit FollowUp', description: err.message });
            console.error(err);
          });
      }
    } else if (type === 'create') {
      createFollowUp()
        .then((res: any) => {
          setApiData(res);
          setLoading(false);
        })
        .catch((err: any) => {
          setLoading(false);
          notification.error({ message: 'Failed to create FollowUp', description: err.message });
          console.error(err);
        });
    }
  }, [import_id, id, type, status, refreshKey]);

  const handleSubmit = (values: FollowUpRequest) => {
    const data = form.getFieldsValue();

    if (editable) {
      setLoading(true);

      const {
        service_charges,
        product_id,
        service_id,
        line_type,
        qty,
        billing_qty,
        billing_days,
        start_date,
        end_date,
        expire_date,
        ...rest
      } = data;

      // ONLY SOURCE OF SERVICE LINES = FORM
      const serviceLines = (service_charges || []).map((item: any) => ({
        //id: item.id ?? null,
        service_charge_id: item.service_charge_id,
        qty: item.qty ?? 0,
      }));

      const submissionData = {
        ...rest,
        ...values,

        reference_code: String(referenceCode),
        customer_id: customerId,
        accepted: acceptedFields ?? [],
        status: FollowUpData?.status ?? 'DRAFT',
        import_id: import_id ?? FollowUpData?.import_id,

        service_lines: serviceLines,
      };

      if (type === 'create') {
        storeFollowUp(submissionData)
          .then((res: any) => {
            setLoading(false);
            navigate(`/view-follow-up`, { state: { id: res?.data?.id } });
          })
          .catch((err: any) => {
            notificationController.error({ message: err.message });
            setLoading(false);
          });
      } else if (type === 'edit' && followUpId && import_id) {
        updateFollowUp(Number(id), submissionData)
          .then(() => {
            setLoading(false);
            navigate(`/view-follow-up`, { state: { id: followUpId, import_id } });
          })
          .catch((err: any) => {
            notificationController.error({ message: err.message });
            setLoading(false);
          });
      }
    }

    console.log('Form Submitted');
  };

  useEffect(() => {
    const buttons = {
      'save-button': editable && (
        <BaseButton
          type="primary"
          loading={isLoading}
          size="small"
          onClick={() => {
            form
              .validateFields()
              .then((values) => {
                handleSubmit(values);
              })
              .catch((error) => {
                console.error('Validation failed:', error);
              });
          }}
        >
          {t('Save')}
        </BaseButton>
      ),
      'cancel-button': editable && (
        <BaseButton onClick={() => navigate('/follow-ups')} size="small" style={{ marginRight: '8px' }}>
          {t('Cancel')}
        </BaseButton>
      ),
      'edit-button': type === 'view' && followUpId && status === 'DRAFT' && (
        <BaseButton
          type="primary"
          onClick={() => navigate('/edit-follow-up', { state: { id: id, import_id: FollowUpData?.import_id } })}
          size="small"
          style={{ marginRight: '8px' }}
        >
          {t('Edit')}
        </BaseButton>
      ),
      'follow-up-button': type === 'view' && followUpId && canCreateFollowUp && (
        <BaseButton
          type="primary"
          size="small"
          onClick={async () => {
            try {
              const res = await createNextFollowUp(followUpId);

              notificationController.success({
                message: 'Follow-up created successfully',
              });

              navigate('/view-follow-up', {
                state: {
                  id: res?.data?.id,
                  import_id: FollowUpData?.import_id,
                },
              });
            } catch (error: any) {
              notificationController.error({
                message: error.message || 'Failed to create follow-up',
              });
            }
          }}
        >
          {t('Extend Follow-Up')}
        </BaseButton>
      ),
    };

    Object.entries(buttons).forEach(([key, button]) => {
      if (button) addHeaderButton(key, button);
    });

    return () => {
      Object.keys(buttons).forEach(removeHeaderButton);
    };
  }, [
    type,
    followUpId,
    editable,
    addHeaderButton,
    removeHeaderButton,
    t,
    navigate,
    isLoading,
    form,
    handleSubmit,
    id,
    status,
  ]);

  return (
    <>
      <BaseRow gutter={[16, 16]}>
        <BaseCol span={24}>
          <StatusBar
            id={id ?? null}
            status={status}
            setStatus={setStatus}
            wfActions={wfActions || []}
            currentType={type}
            workflowType={'follow-up'}
            onViewInvoicesClick={() => setActiveTab('9')}
            failureActions={failureActions}
            triggerRefresh={() => setRefreshKey((prev) => prev + 1)}
          />
        </BaseCol>

        <BaseCol span={24}>
          <BaseCard id="FollowUpForm" title={pageTitle} padding="1.25rem">
            <BaseRow>
              <BaseCol span={24}>
                <Form
                  form={form}
                  name="FollowUpForm"
                  onFinish={handleSubmit}
                  labelCol={{ lg: { span: 6 }, md: { span: 6 }, sm: { span: 24 } }}
                  labelAlign="left"
                  labelWrap
                  wrapperCol={{ lg: { span: 16 }, md: { span: 18 }, sm: { span: 24 } }}
                  size="small"
                >
                  {type === 'create' && (
                    <Form.Item
                      name="import_id"
                      label="Select Import"
                      rules={[{ required: true, message: 'Please select an import' }]}
                    >
                      <Select
                        placeholder="Select Import"
                        options={importOptions.map((item) => ({
                          label: item.label,
                          value: item.value,
                        }))}
                        onChange={(value) => {
                          const selected = importOptions.find((item) => item.value === value);
                          if (selected) {
                            populateImportFields(selected);
                          }
                        }}
                      />
                    </Form.Item>
                  )}
                  <Tabs
                    items={type == 'create' ? items?.slice(0, 2) : items}
                    activeKey={activeTab}
                    onChange={(key) => setActiveTab(key)}
                  />
                </Form>
              </BaseCol>
            </BaseRow>
          </BaseCard>
        </BaseCol>
      </BaseRow>
    </>
  );
};
export default FollowUpForm;
